import { render } from "./ReportBody.vue?vue&type=template&id=584b4a68&scoped=true"
import script from "./ReportBody.vue?vue&type=script&lang=js"
export * from "./ReportBody.vue?vue&type=script&lang=js"

import "./ReportBody.vue?vue&type=style&index=0&id=584b4a68&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-584b4a68"],['__file',"src/components/reports/toxicology/ReportBody.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "584b4a68"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('584b4a68', __exports__)) {
    console.log('reload')
    api.reload('584b4a68', __exports__)
  }
  
  module.hot.accept("./ReportBody.vue?vue&type=template&id=584b4a68&scoped=true", () => {
    console.log('re-render')
    api.rerender('584b4a68', render)
  })

}


export default __exports__